"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function NotificationsBadge(_a) {
    var notifications = _a.notifications, onClick = _a.onClick;
    return react_1.default.createElement("div", { className: 'storybook-users-notifications-badge-wrapper', onClick: onClick },
        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'notification', className: 'storybook-icons-notification' }),
        notifications.data.length > 0 &&
            react_1.default.createElement("div", { className: 'storybook-users-notifications-badge cursor-pointer' },
                react_1.default.createElement("span", { className: 'mx-auto pointer-events-none' }, notifications.meta.total)));
}
exports.default = NotificationsBadge;
